import _ from 'lodash';
import React, { useMemo } from 'react';
import { createDirectoryFilterFromFilterParams } from '../../../../data/filters/directory/createDirectoryFilterFromFilterParams/createDirectoryFilterFromFilterParams';
import { useDirectoryItem } from '../../../../data/hooks/directory/directoryHooks';
import { useDirectoryFilter } from '../../../../data/hooks/directory/useDirectoryFilter';
import { useDirectorySubItems } from '../../../../data/hooks/directory/useDirectorySubItems/useDirectorySubItems';
import { useEvent } from '../../../../data/hooks/eventHooks';
import ListTitle from '../../../elements/ListTitle';
import DirectoryListItem from './DirectoryListItem/DirectoryListItem';

function Directory(props) {
    const { eventId, itemId } = props,
        event = useEvent(eventId),
        item = useDirectoryItem(eventId, itemId),
        filterParams = useDirectoryFilter(eventId, itemId),
        filteredItems = useDirectorySubItems(eventId, itemId, {
            filter: createDirectoryFilterFromFilterParams(filterParams),
        }),
        byCategories = useMemo(
            () =>
                [
                    ..._(filteredItems)
                        .map((item) => item.categories)
                        .flatten()
                        .uniq()
                        .map((cat) => ({
                            title: cat,
                            items: _(filteredItems)
                                .filter((item) => {
                                    return _.includes(item.categories, cat);
                                })
                                .value(),
                        }))
                        .value(),
                    {
                        title: item.name ?? null,
                        items: filteredItems.filter((item) => item.is_exhibitor).filter((item) => !item.categories || !item.categories.length),
                    },
                ].filter((cat) => cat.items.length),
            [filteredItems]
        );

    return (
        <div>
            {byCategories.map((category, i) => (
                <div className="marginBottom" key={category.title}>
                    {category.title ? (
                        <ListTitle
                            style={{
                                textTransform: 'capitalize',
                            }}>
                            {category.title}
                        </ListTitle>
                    ) : null}
                    <ul className="list">
                        {category.items.map((item) => (
                            <DirectoryListItem event={event} item={item} key={item.id} />
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}

export default Directory;
